import React from 'react';

import {
    withStyles,
    ListItem,
    Grid,
    ListItemText,
    Typography,
    Button,
    ButtonBase,
    Snackbar,
    Divider
} from '@material-ui/core';

import {
    withRouter,
} from "react-router-dom"

import AppData from '../../model/AppData';
import MBack from '../view/MBack';
import DeviceEventEmitter, { EventName } from '../../control/event';
import Cancel from '@material-ui/icons/Cancel'
import Apis from '../../network/Apis';

const styles = (theme) => ({
    commitBtn: {
        background: '#007AFF',
        borderRadius: 10,
        color: 'white',
        height: 45,
        width: "80%",
        margin: theme.spacing(5, 0, 2, 0),
        fontSize: 14,
        fontWeight: theme.typography.fontWeightBold,
    },
    textfield: {
        backgroundColor: 'transparent',
        fontSize: 13,
        height: 30,
        marginLeft: 10,
        borderRadius: 10,
        width: '80%',
        justifyContent: 'flex-end',
        border: 'none',
        outline: 'none',
        padding: theme.spacing(1, 1, 1, 1),
    },
});

class RealNameDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            nickname: '', //真实姓名
            nicknumber: '', //身份证号
            phonenumber: '', //手机号
            checknumber: '', //验证码
            snackopened: false,
            message: '',
            codeTip: '获取验证码',
        };

        this._getModifyInfoBack = this._getModifyInfoBack.bind(this);
        this._onCancel = this._onCancel.bind(this);
        this._saveInfo = this._saveInfo.bind(this);
    }

    //提交实名认证
    async _saveInfo() {

        let { nickname, nicknumber, phonenumber, checknumber } = this.state;

        if (!nickname || nickname === '') {
            this.setState({ message: '姓名不能为空', snackopened: true });
            return;
        }

        if (!nicknumber || nicknumber === '') {
            this.setState({ message: '身份证号不能为空', snackopened: true });
            return;
        }

        if (!phonenumber || phonenumber === '') {
            this.setState({ message: '手机号码不能为空', snackopened: true });
            return;
        }

        if (!checknumber || checknumber === '') {
            this.setState({ message: '请输入验证码', snackopened: true });
            return;
        }

        let {customerId, token } = this.props.match.params;


        let result = await Apis.encryptionRealName(phonenumber, nicknumber, nickname, token, customerId, checknumber);
        if (result.code == 200) {
            this.setState({ message: result.msg, snackopened: true });
        } else {
            this.setState({ message: result.msg, snackopened: true });
        }

    }

    componentDidMount() {
        let {os } = this.props.match.params;
        if (os != '' && os != 0) {
            AppData.os = os
        }

        DeviceEventEmitter.on(EventName.ON_MODIFY_NAME, this._getModifyInfoBack, this);
    }

    componentWillUnmount() {
        DeviceEventEmitter.off(EventName.ON_MODIFY_NAME, this._getModifyInfoBack, this);
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    }

    _getModifyInfoBack(result) {
        if (result.RetCode === 0) {
            this.setState({ message: '信息修改成功', snackopened: true });
            this.timeout = setTimeout(() => {
                window.history.back();
            }, 2000);
        } else {
            this.setState({ message: '修改失败', snackopened: true });
        }
    }

    _onCancel() {
        this.setState({ nickname: '' });
    }

    _getPhoneCode = async () => {
        if (!this.validatePhone(this.state.phonenumber)) {
            this.setState({ message: '请正确填写手机号码', snackopened: true });
            return;
        }

        let result = await Apis.encryptionSendCode(this.state.phonenumber);
        console.log('encryptionSendCode', result);
        if (result.code == 200) {
            this._verifyCodeTimeAction();
        } else {
            this.setState({ message: result.msg, snackopened: true });
        }
    }
    validatePhone = (phone) => {
        // console.log('validatePhone', phone);
        // var re = /^1[3-9]\d{9}$/;
        // return  re.test(phone);
        return phone.length > 0 && phone.length <= 11;
    }

    _verifyCodeTimeAction() {
        const codeTime = 60;
        this.setState({
            codeTip: codeTime,
        });
        const now = Date.now()
        const overTimeStamp = now + codeTime * 1000 + 100/*过期时间戳（毫秒） +100 毫秒容错*/
        this.interval = setInterval(() => {
            /* 切换到后台不受影响*/
            const nowStamp = Date.now()
            if (nowStamp >= overTimeStamp) {
                /* 倒计时结束*/
                this.interval && clearInterval(this.interval);
                this.setState({
                    codeTip: '获取验证码',
                });
            } else {
                const leftTime = parseInt((overTimeStamp - nowStamp) / 1000, 10)
                this.setState({
                    codeTip: leftTime,

                });
            }
        }, 1000);
    }

    // 个人信息
    render() {
        const { classes } = this.props;
        const { nickname, snackopened, message } = this.state;

        return (
            <MBack title="实名认证" >
                <Grid style={{ height: 15 }}></Grid>
                <ListItemText primary={<Typography style={{ color: '#878787', fontSize: 12, marginLeft: 10, marginRight: 10 }}>您还不是主播哦，成为主播需要实名认证，请输入一下资料，我 们将会确保您的隐私信息安全。提交后我们将会尽快与您联系！</Typography>} />

                <ListItem disableRipple button style={{ backgroundColor: '#fff', height: 45 }}>
                    <ListItemText primary={<Typography style={{ color: '#0D0D0D', fontSize: 14, width: 70 }}>手机号码</Typography>} />
                    <input
                        onChange={event => this.setState({ phonenumber: event.target.value })}
                        type='text'
                        className={classes.textfield}
                        placeholder='请输入手机号码'
                    />
                    <Button style={{
                        position: 'absolute',
                        right: 0,
                        marginRight: 10,
                        fontSize: 12
                    }} onClick={() => this._onCancel()}>
                        <div onClick={() => this._getPhoneCode()}>{this.state.codeTip}</div>
                    </Button>
                </ListItem>
                <Divider style={{ backgroundColor: '#F2F2F2', marginLeft: 13, marginRight: 13 }} />
                <ListItem disableRipple button style={{ backgroundColor: '#fff', height: 45 }}>
                    <ListItemText primary={<Typography style={{ color: '#0D0D0D', fontSize: 14, width: 70 }}>验证码</Typography>} />
                    <input
                        onChange={event => this.setState({ checknumber: event.target.value })}
                        type='text'
                        className={classes.textfield}
                        placeholder='请输入验证码'
                    />
                    {/* <Button style={{
                        position: 'absolute',
                        right: 0,
                    }} onClick={() => this._onCancel()}>
                        <Cancel style={{ color: '#E2E2E2', }}></Cancel>
                    </Button> */}
                </ListItem>
                <Divider style={{ backgroundColor: '#F2F2F2', marginLeft: 13, marginRight: 13 }} />
                <ListItem disableRipple button style={{ backgroundColor: '#fff', height: 45 }}>
                    <ListItemText primary={<Typography style={{ color: '#0D0D0D', fontSize: 14, width: 70 }}>真实姓名</Typography>} />
                    <input
                        onChange={event => this.setState({ nickname: event.target.value })}
                        type='text'
                        className={classes.textfield}
                        placeholder='输入姓名'
                    />
                    {/* <Button style={{
                        position: 'absolute',
                        right: 0,
                    }} onClick={() => this._onCancel()}>
                        <Cancel style={{ color: '#E2E2E2', }}></Cancel>
                    </Button> */}
                </ListItem>
                <Divider style={{ backgroundColor: '#F2F2F2', marginLeft: 13, marginRight: 13 }} />
                <ListItem disableRipple button style={{ backgroundColor: '#fff', height: 45 }}>
                    <ListItemText primary={<Typography style={{ color: '#0D0D0D', fontSize: 14, width: 70 }}>身份证号</Typography>} />
                    <input
                        onChange={event => this.setState({ nicknumber: event.target.value })}
                        type='text'
                        className={classes.textfield}
                        placeholder='请输入身份证号码'
                    />
                    {/* <Button style={{
                        position: 'absolute',
                        right: 0,
                    }} onClick={() => this._onCancel()}>
                        <Cancel style={{ color: '#E2E2E2', }}></Cancel>
                    </Button> */}
                </ListItem>
                <Divider style={{ backgroundColor: '#F2F2F2', marginLeft: 13, marginRight: 13 }} />

                <Grid style={{ height: 5 }}></Grid>
                <Grid container justifyContent='center' >
                    <ButtonBase
                        className={classes.commitBtn}
                        onClick={ ()=>this._saveInfo()}
                    >提 交</ButtonBase>
                </Grid>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackopened}
                    onClose={() => this.setState({ snackopened: false })}
                    message={message}
                    autoHideDuration={3000}>
                </Snackbar>
            </MBack>
        );
    }
}

export default withRouter( withStyles(styles)(RealNameDialog));